import apiFetch from '../apiFetch'

export default function (token, purchasePresentId) {
  return apiFetch({ endPoint: `PurchasePresent/${purchasePresentId}`, method: 'GET', body: null, token: token })
}
